export const Roles = {
  supportUser: "SUPPORT USER",
  clinicAdmin: "CLINIC ADMIN",
  superUser: "SUPER USER",
};
